import type {
  AppShellContentVariantParams,
  AppShellSkeletonTargetParams,
  LayoutContentSkeletonVariant,
  LayoutContentSkeletonVariantParams,
} from '../types/mainLayout.type';

/**
 * El shell imita MainLayout, así que solo aplica a rutas que lo dibujan: `requiresAuth`
 * no alcanza, porque hay rutas privadas con `EmptyLayout` o sin layout. Sin sesión,
 * `validateAuth` redirige a log-in, así que también queda afuera.
 */
export function isAppShellSkeletonTarget({
  hasSession,
  requiresAuth,
  usesMainLayout,
}: AppShellSkeletonTargetParams): boolean {
  return hasSession && requiresAuth && usesMainLayout;
}

/**
 * Antes de los guards el KYC no se conoce: en la home se reusa la forma de la recarga
 * anterior para que el shell y el skeleton del layout coincidan.
 */
export function getAppShellContentVariant({
  isHomeRoute,
  storedVariant,
}: AppShellContentVariantParams): LayoutContentSkeletonVariant {
  if (!isHomeRoute) return 'generic';

  return storedVariant ?? 'generic';
}

/**
 * La home dibuja otra pantalla mientras el onboarding no termina, así que su skeleton
 * depende de la empresa; fuera de la home la forma es genérica.
 */
export function getLayoutContentSkeletonVariant({
  isHomeRoute,
  isCompanyComplete,
}: LayoutContentSkeletonVariantParams): LayoutContentSkeletonVariant {
  if (!isHomeRoute) return 'generic';

  return isCompanyComplete ? 'home' : 'onboarding';
}
